// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import toast from 'react-hot-toast';
// import {
//   Box, Stack, Button, FormControl, IconButton, OutlinedInput,
//   Grid, Typography, InputAdornment, InputLabel, Paper, useTheme, useMediaQuery
// } from '@mui/material';
// import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
// import { Formik } from 'formik';
// import { LoadingButton } from '@mui/lab';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
// import { ChangePasswordRequest } from '../../store/reducers/LoginReducer';

// const Changepassword = () => {
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState({ old: false, new: false, confirm: false });
//   const navigate = useNavigate();
//   const recID = sessionStorage.getItem("EmpId");
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   const toggleShowPassword = (field) => {
//     setShowPassword((prev) => ({
//       ...prev,
//       [field]: !prev[field],
//     }));
//   };

//   const handleSave = async (values, resetForm) => {
//     setLoading(true);
//     try {
//       const { oldpassword, newpassword } = values;
//       const result = await ChangePasswordRequest({
//         RecordID: recID,
//         Oldpassword: oldpassword,
//         Newpassword: newpassword,
//       });

//       if (result?.Status === "Y") {
//         toast.success(result.Msg);
//         resetForm();
//         navigate('/');
//       } else {
//         toast.error(result?.Msg || "Change password failed");
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       toast.error("Something went wrong. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box display="flex" justifyContent="center" alignItems="center" height="100vh" className="wrapper">
//       <IconButton sx={{ position: "absolute", top: 20, right: 20 }} color="info">
//         <HelpOutlineOutlinedIcon />
//       </IconButton>

//       <Formik
//         initialValues={{
//           oldpassword: '',
//           newpassword: '',
//           confirmpassword: '',
//         }}
//         validate={(values) => {
//           const errors = {};
//           if (!values.oldpassword) {
//             errors.oldpassword = 'Please enter Old Password';
//           }

//           if (!values.newpassword) {
//             // errors.newpassword = 'New password is required';
//             errors.newpassword = 'Please enter New Password';
//           } else if (values.newpassword.length < 8) {
//             errors.newpassword = 'Password must be at least 8 characters';
//           } else if (!/[A-Z]/.test(values.newpassword)) {
//             errors.newpassword = 'Password must include an uppercase letter';
//           } else if (!/[!@#$%^&*]/.test(values.newpassword)) {
//             errors.newpassword = 'Password must include a special character';
//           }

//           if (!values.confirmpassword) {
//             errors.confirmpassword = 'Please Confirm your password';
//           } else if (values.newpassword !== values.confirmpassword) {
//             // errors.confirmpassword = 'Passwords do not match';
//                errors.confirmpassword = 'New Password and Confirm Password must match';
//           }

//           return errors;
//         }}
//         onSubmit={(values, { resetForm }) => handleSave(values, resetForm)}
//       >
//         {({
//           values, errors, touched, handleBlur, handleChange, handleSubmit, resetForm
//         }) => (
//           <form onSubmit={handleSubmit}>
//             <Paper
//               elevation={3}
//               sx={{
//                 padding: 4,
//                 width: isMobile ? '90vw' : 400,
//                 borderRadius: 3,
//                 backgroundColor: 'white',
//               }}
//             >
//               <Stack spacing={3}>
//                 <Typography variant="h5" align="center" fontWeight={600}>
//                   Change Password
//                 </Typography>

//                 {['oldpassword', 'newpassword', 'confirmpassword'].map((field, index) => {
//                   const labelMap = {
//                     oldpassword: 'Old Password',
//                     newpassword: 'New Password',
//                     confirmpassword: 'Confirm Password'
//                   };
//                   return (
//                     <FormControl key={field} fullWidth variant="outlined" required>
//                       <InputLabel htmlFor={field}>{labelMap[field]}</InputLabel>
//                       <OutlinedInput
//                         id={field}
//                         name={field}
//                         type={showPassword[field === 'oldpassword' ? 'old' : field === 'newpassword' ? 'new' : 'confirm'] ? 'text' : 'password'}
//                         value={values[field]}
//                         onBlur={handleBlur}
//                         onChange={handleChange}
//                         error={touched[field] && Boolean(errors[field])}
//                         endAdornment={
//                           <InputAdornment position="end">
//                             <IconButton onClick={() =>
//                               toggleShowPassword(field === 'oldpassword' ? 'old' : field === 'newpassword' ? 'new' : 'confirm')
//                             } edge="end">
//                               {showPassword[field === 'oldpassword' ? 'old' : field === 'newpassword' ? 'new' : 'confirm']
//                                 ? <VisibilityOffIcon /> : <VisibilityIcon />}
//                             </IconButton>
//                           </InputAdornment>
//                         }
//                         label={labelMap[field]}
//                       />
//                       {touched[field] && errors[field] && (
//                         <Typography color="error" fontSize="0.75rem" mt={0.5}>
//                           {errors[field]}
//                         </Typography>
//                       )}
//                     </FormControl>
//                   );
//                 })}

//                 <Stack direction="row" justifyContent="flex-end" spacing={2}>
//                   <LoadingButton
//                     type="submit"
//                     variant="contained"
//                     color="primary"
//                     loading={loading}
//                   >
//                     Save
//                   </LoadingButton>
//                   <Button variant="outlined" color="secondary" onClick={resetForm}>
//                     Cancel
//                   </Button>
//                 </Stack>
//               </Stack>
//             </Paper>
//           </form>
//         )}
//       </Formik>
//     </Box>
//   );
// };

// export default Changepassword;
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import {
  Stack,
  Grid,
  TextField,
  Button,
  Box,
  IconButton,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Typography,
  Paper,
  Card,
  FormControlLabel,
  Checkbox,
  Link,
  useMediaQuery,
} from "@mui/material";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { Formik } from 'formik';
import { LoadingButton } from '@mui/lab';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { ChangePasswordRequest } from '../../store/reducers/LoginReducer';
// import toast from 'react-hot-toast';
// import background from "../../assets/img/ESS_final.png";
import background from "../../assets/img/ESS_CoverImg1.png";
import { styled } from "@mui/system";
import * as Yup from "yup";
import { useTheme } from '@emotion/react';


const FlexBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
}));

const JustifyBox = styled(FlexBox)(() => ({
  justifyContent: "center",
}));

const ContentBox = styled(Box)(({ theme }) => ({
  height: "100%",
  padding: theme.spacing(4),
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    minHeight: "100vh",
    justifyContent: "center",
  },
}));

const JWTRoot = styled(JustifyBox)(({ theme }) => ({
  minHeight: "90vh",
  "& .card": {
    width: "100%",
    minHeight: "90vh",
    display: "flex",
    // borderRadius: 12,
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      boxShadow: "none",
      borderRadius: 0,
      minHeight: "90vh",
    },
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#f5f9fa",
    borderRadius: "8px",
    "& fieldset": {
      borderColor: "#e0e0e0",
    },
    "&:hover fieldset": {
      borderColor: "#00796b",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#00796b",
    },
  },
  "& .MuiInputLabel-root": {
    color: "#666",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#00796b",
  },
}));

const StyledOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
  backgroundColor: "#f5f9fa",
  borderRadius: "8px",
  "& fieldset": {
    borderColor: "#e0e0e0",
  },
  "&:hover fieldset": {
    borderColor: "#00796b",
  },
  "&.Mui-focused fieldset": {
    borderColor: "#00796b",
  },
}));


const LoginButton = styled(LoadingButton)(({ theme }) => ({
  // backgroundColor: "#00796b",
  background: "#0A4063",
  background: "radial-gradient(circle, rgba(10, 64, 99, 1) 40%, rgba(6, 128, 150, 1) 100%)",
  color: "#ffffff",
  padding: "12px 0",
  borderRadius: "8px",
  fontSize: "16px",
  fontWeight: 600,
  textTransform: "none",
  // "&:hover": {
  //   backgroundColor: "#00695c",
  // },
  "&:hover": {
    background: "radial-gradient(circle, rgba(10, 64, 99, 1) 40%, rgba(6, 128, 150, 1) 100%)",
  },

  "& .MuiCircularProgress-root": {
    color: "#ffffff",
  },
}));

const Changepassword = () => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState({ old: false, new: false, confirm: false });
  const navigate = useNavigate();
  const recID = sessionStorage.getItem("EmpId");
  const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const toggleShowPassword = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSave = async (values, resetForm) => {
    setLoading(true);
    try {
      const { oldpassword, newpassword } = values;
      const result = await ChangePasswordRequest({
        RecordID: recID,
        Oldpassword: oldpassword,
        Newpassword: newpassword,
      });

      if (result?.Status === "Y") {
        toast.success(result.Msg);
        resetForm();
        navigate('/');
      } else {
        toast.error(result?.Msg || "Change password failed");
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <JWTRoot>
      <Card
        className="card"
        sx={{
          width: "100%",
          boxShadow: { xs: "none", sm: 3 },
          borderRadius: { xs: 0, sm: 0 },

          // ✅ Add this
          backgroundImage: {
            xs: `url(${background})`,
            sm: "none",
          },
          backgroundSize: {
            xs: "cover",
            sm: "unset",
          },
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <Grid container sx={{ height: "100vh" }}>
          <Grid item sm={7} xs={12}>

            <ContentBox
              sx={{
                mx: "auto",
                width: "100%",
                maxWidth: { xs: "95%", sm: 420 },
                // px: { xs: 2, sm: 6 },
                // py: { xs: 4, sm: 6 },
                paddingRight: { xs: 2, sm: 6 },
                paddingLeft: { xs: 1, sm: 6 },
                paddingTop: { xs: 0, sm: 0 },
                paddingBottom: { xs: 0, sm: 0 },
                backgroundColor: "#ffffff",
                // ✅ Transparent on xs so background shows
                backgroundColor: {
                  xs: "rgba(255,255,255,0.85)",
                  sm: "#ffffff",
                },
                backdropFilter: {
                  xs: "blur(15px)",
                  sm: "none",
                },

              }}
            >
              {/* Header */}
              <Box mb={2}>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "20px", sm: "30px" },
                    fontWeight: 600,
                    // mb: 0.5,

                    // background: "linear-gradient(180deg, rgba(10,64,99,1) 53%, rgba(6,128,150,1) 100%)",
                    background: "linear-gradient(180deg,rgba(10, 64, 99, 1) 37%, rgba(6, 128, 150, 1) 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    color: "transparent",
                    textAlign: "center"
                  }}
                >
                  Change Password
                </Typography>
              </Box>
              <Formik
                initialValues={{
                  oldpassword: '',
                  newpassword: '',
                  confirmpassword: '',
                }}
                validate={(values) => {
                  const errors = {};
                  if (!values.oldpassword) {
                    errors.oldpassword = 'Please enter Old Password';
                  }

                  if (!values.newpassword) {
                    // errors.newpassword = 'New password is required';
                    errors.newpassword = 'Please enter New Password';
                  } else if (values.newpassword.length < 8) {
                    errors.newpassword = 'Password must be at least 8 characters';
                  } else if (!/[A-Z]/.test(values.newpassword)) {
                    errors.newpassword = 'Password must include an uppercase letter';
                  } else if (!/[!@#$%^&*]/.test(values.newpassword)) {
                    errors.newpassword = 'Password must include a special character';
                  }

                  if (!values.confirmpassword) {
                    errors.confirmpassword = 'Please Confirm your password';
                  } else if (values.newpassword !== values.confirmpassword) {
                    // errors.confirmpassword = 'Passwords do not match';
                    errors.confirmpassword = 'New Password and Confirm Password must match';
                  }

                  return errors;
                }}
                onSubmit={(values, { resetForm }) => handleSave(values, resetForm)}
              >
                {({
                  values, errors, touched, handleBlur, handleChange, handleSubmit, resetForm
                }) => (
                  <form onSubmit={handleSubmit}>

                    <Stack spacing={2}>
                      {['oldpassword', 'newpassword', 'confirmpassword'].map((field, index) => {
                        const labelMap = {
                          oldpassword: 'Old Password',
                          newpassword: 'New Password',
                          confirmpassword: 'Confirm Password'
                        };
                        return (
                          <FormControl key={field} fullWidth variant="outlined" required>
                            {/* <InputLabel htmlFor={field}>{labelMap[field]}</InputLabel> */}
                            <StyledTextField
                              id={field}
                              name={field}
                              type={showPassword[field === 'oldpassword' ? 'old' : field === 'newpassword' ? 'new' : 'confirm'] ? 'text' : 'password'}
                              value={values[field]}
                              fullWidth
                              onBlur={handleBlur}
                              onChange={handleChange}
                              error={touched[field] && Boolean(errors[field])}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Box sx={{ color: "#999", fontSize: "17px" }}>🔒</Box>
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton onClick={() =>
                                      toggleShowPassword(field === 'oldpassword' ? 'old' : field === 'newpassword' ? 'new' : 'confirm')
                                    } edge="end">
                                      {showPassword[field === 'oldpassword' ? 'old' : field === 'newpassword' ? 'new' : 'confirm']
                                        ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                                sx: {
                                  paddingRight: "14px",
                                  paddingLeft: "7px",
                                },
                              }}
                              label={labelMap[field]}
                            />
                            {touched[field] && errors[field] && (
                              <Typography color="error" fontSize="0.75rem" mt={0.5}>
                                {errors[field]}
                              </Typography>
                            )}
                          </FormControl>
                        );
                      })}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          mt: 1,
                        }}
                      >

                        <Link
                          onClick={() => navigate('/')}
                          sx={{
                            // color: "#00796b",
                            color: "#608dcb",
                            fontSize: "14px",
                            cursor: "pointer",
                            textDecoration: "none",
                            "&:hover": {
                              textDecoration: "underline",
                            },
                          }}
                        >
                          Back
                        </Link>

                      </Box>
                      <LoginButton
                        type="submit"
                        variant="contained"
                        // color="primary"
                        loading={loading}
                        fullWidth
                      >
                        Save
                      </LoginButton>
                      {/* <Button variant="outlined" color="secondary" onClick={resetForm}>
                          Cancel
                        </Button> */}
                    </Stack>

                  </form>
                )}
              </Formik>
            </ContentBox>

          </Grid>



          {/* Right Side: Image */}
          <Grid
            item
            sm={5}
            xs={false}
            sx={{
              display: { xs: "none", sm: "flex" },
              alignItems: "center", // CHANGED: Added to center vertically
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                backgroundImage: `url(${background})`,
                // backgroundSize: "cover",
                backgroundSize: "contain",
                backgroundSize: "100% 100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                // height: "100%",
                height: "98vh",
                minHeight: "100vh",
                width: "100%",
              }}

            />
          </Grid>
        </Grid>

      </Card>
    </JWTRoot>
  );
};

export default Changepassword;